import Vue from 'vue'
import TelepathyComponent from './Telepathy.vue'

interface Options {
  prefix?: string
  addComponent?: boolean | string
}

export default class Telepathy {
  private static readonly _elements = new Map()

  static install(vue: typeof Vue, options: Options = {}) {
    const {prefix = 'telepathy', addComponent = false} = options
    vue.prototype.$telepathy = (name: string, eventInitDict: CustomEventInit) => {
      const event = new CustomEvent(`${prefix}-${name}`, eventInitDict)
      Telepathy._elements.forEach((binding, el: any) => {
        el.dispatchEvent(event)
      })
    }

    vue.directive(prefix, {
      bind(el, binding) {
        Telepathy._elements.set(el, binding)
      },
      unbind(el) {
        Telepathy._elements.delete(el)
      },
    })

    if(addComponent) {
      const name = typeof addComponent === 'string' ? addComponent : 'Telepathy'
      Vue.component(name, TelepathyComponent)
    }
  }
}
